/** A11: read-only marketing budget-reallocation recommendations (apps/api/src/platform/reallocation.ts). */
import { z } from 'zod';
import { CentsSchema, EpochMsSchema, UlidSchema } from './common';

export const ReallocationCampaignInputSchema = z.object({
  id: UlidSchema,
  name: z.string(),
  spendCents: CentsSchema,
  conversions: z.number().int().nonnegative(),
  valueCents: CentsSchema,
});

export const ReallocationRecommendationSchema = z.object({
  fromCampaignId: UlidSchema,
  fromCampaignName: z.string(),
  toCampaignId: UlidSchema,
  toCampaignName: z.string(),
  shiftCents: CentsSchema,
  reason: z.string(),
  arithmetic: z.array(z.string()),
});

export const InsufficientDataCampaignSchema = z.object({
  campaignId: UlidSchema,
  campaignName: z.string(),
  conversions: z.number().int().nonnegative(),
  reason: z.string(),
});

export const ReallocationResponseSchema = z.object({
  orgId: UlidSchema,
  minSampleConversions: z.number().int().positive(),
  evaluated: z.array(
    z.object({
      campaignId: UlidSchema,
      name: z.string(),
      spendCents: CentsSchema,
      conversions: z.number().int().nonnegative(),
      valueCents: CentsSchema,
      cpaCents: z.number().nullable(),
      roas: z.number().nullable(),
    }),
  ),
  recommendations: z.array(ReallocationRecommendationSchema),
  excludedForLowSample: z.array(InsufficientDataCampaignSchema),
  generatedAt: EpochMsSchema,
});
